import { render, staticRenderFns } from "./sysuser_receive_config.vue?vue&type=template&id=49d365b0&scoped=true"
import script from "./sysuser_receive_config.vue?vue&type=script&lang=js"
export * from "./sysuser_receive_config.vue?vue&type=script&lang=js"
import style0 from "./sysuser_receive_config.vue?vue&type=style&index=0&id=49d365b0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d365b0",
  null
  
)

export default component.exports